// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__HNk5C","footer":"ModalFilter_footer__2TNLY"};